import { ChangeDetectorRef, Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { AuthService } from "@core/auth.service";
import { CaptchaService } from "@core/captcha.service";
import { MySnackBarService } from "@core/my-snack-bar.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { getAuth, updateEmail } from "firebase/auth";
import { Subject, Subscription, interval, takeUntil } from "rxjs";
import { bounceIn } from "src/app/animations/custom.animation";
import { CommonVariable } from "src/app/app.constants";
import { AccountRepositoryService } from "src/app/pages/account/account-repository.service";
import { VerifyPhoneNumberComponent } from "../verify-phone-number/verify-phone-number.component";
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Data } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { NgClass } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "app-mobile-number-update",
    templateUrl: "./mobile-number-update.component.html",
    styleUrls: ["./mobile-number-update.component.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        MatProgressSpinner,
        MatIcon,
        TranslatePipe,
    ],
})
export class MobileNumberUpdateComponent implements OnInit, OnDestroy {
  isNumberInvalid: boolean;
  countryCode: any;
  msn: any;
  cell1TelInput = {
    initialCountry: CommonVariable.countryCode,
    separateDialCode: false,
  };
  @ViewChild("mobileNumber") mobileNumber: ElementRef;
  phoneInValid: boolean = false;
  phoneNumber;
  selectedData = {
    iso2: "",
    number: "",
    dialCode: "",
  };
  spinnerAnimation: boolean;
  progressBar: number;
  timer$: any;
  sub: any;
  proceed = true;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  newPhoneNumber: string;
  newDialCode: string;
  dialCode: string;
  otpLoader = false;
  private unsubscribe$ = new Subject<void>();
  UserDetailsSubscription: Subscription;
  tokenValidaterSub: Subscription;
  phoneNumberForm: FormGroup;
  @ViewChild("phoneNumberInput", { static: true }) phoneNumberInput: ElementRef;
  constructor(
    private bottomSheetRef: MatBottomSheetRef<MobileNumberUpdateComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheet: MatBottomSheet,
    private authService: AuthService,
    private snackService: MySnackBarService,
    private captchaService: CaptchaService,
    private changeDetectorRef: ChangeDetectorRef,
    private accountService: AccountRepositoryService,
    public translate: TranslateService,
    private angularFireAuth: AngularFireAuth,
    private formBuilder: FormBuilder,
    private ngZone: NgZone,
  ) {

    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.captchaService.otpSent$.next(false);
    this.captchaService?.captchaSolved$?.subscribe(
      (data) => {
        if (data) {
          this.updateProfilePhoneNumber();
        }
      },
      (err) => {
        return err;
      }
    );
    this.captchaService?.otpSent$?.subscribe(
      (data:boolean) => {
      // This variable contain current location Value 
        const currentLocation = location.href.search("account") > -1 || location.href.search("free-reg-complete-profile") > -1;
        if (data && (currentLocation || this.data?.autoOpen)) {
          /* const msg = this.translatedToastMsg?.["1011"]?.[this.selectedLanguage];
          this.authService.showToast(msg ? msg : "OTP has been sent!", "Success", ""); */
          this.authService
            .getConstantsMsg("1011")
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "OTP has been sent!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle success.png",
                  type: "Success",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
          this.openVerifyPhoneNumber();
        }
      },
      (err) => {
        return err;
      }
    );

    this.authService?.otpFail$?.pipe(takeUntil(this.unsubscribe$))?.subscribe({
      next: (data: boolean) => {
        if (data == null) {
          return;
        }
        this.otpLoader = false;
        if (data) {
          this.authService.getConstantsMsg("1015").then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Something went wrong!",
                line_2: "",
              },
              style: {
                icon: "tick circle error.svg",
                type: "Error",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          });
        }
      },
      error: (error) => {
        this.otpLoader = false;
        return error;
      }
    })

    // This method has been called to validate phone numbers
    this.phoneNumberValidation();

    this.UserDetailsSubscription = this.authService.userDetails$.subscribe({
      next: (user: Data) => {
        if (user) {
          const countryCode = user?.country_code;
          const fullMsn = user?.msn;
          if (countryCode && fullMsn && fullMsn?.startsWith(countryCode)) {
            const justMsn = fullMsn?.substring(countryCode?.length);
            const dial = this.normalizeDialCode(countryCode);
            this.phoneNumberForm.get("dialCode").setValue(dial);
            this.phoneNumberForm.get("phoneNumber").setValue(justMsn);
            this.selectedData.dialCode = dial;
            this.phoneNumber = justMsn;
          } else if (countryCode) {
            const dial = this.normalizeDialCode(countryCode);
            this.phoneNumberForm.get("dialCode").setValue(dial);
            this.selectedData.dialCode = dial;
          }
        }
      },
      error: (error) => {
        return error;
      },
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.UserDetailsSubscription?.unsubscribe();
    this.tokenValidaterSub?.unsubscribe();
  }

  openVerifyPhoneNumber() {
    const autoOpen = this.data?.autoOpen ?? false;
    const verifyPhoneNoBottomSheet = this.bottomSheet.open(VerifyPhoneNumberComponent, {
      panelClass: "verify-phone-number-bottom-sheet",
      data: {
        type: "updateMsn",
        msn: this.phoneNumber,
        autoOpen: autoOpen,
      },
      disableClose: autoOpen,
    });

    verifyPhoneNoBottomSheet?.afterDismissed()?.subscribe(
      (data) => {
        if (data === true) {
          if ((location.href.search("free-reg-complete-profile") > -1 && this.data?.isSpoofMsn) || location.href.search("account") > -1 ) {  
            this.updateUserMSN();
            return;
          }
          this.updateEmail()
            .then((response) => {
              if (response === "Success") {
                this.updateUserMSN();
              } else {
                this.authService.getConstantsMsg("1015").then((translatedMsg) => {
                  const defaultMsg = {
                    message: {
                      line_1: "Something went wrong!",
                      line_2: "",
                    },
                    style: {
                      icon: "tick circle error.svg",
                      type: "Error",
                    },
                  };
                  this.authService.showToastMessage(translatedMsg, defaultMsg);
                });
              }
            })
            .catch((error) => {
              return error;
            });
        } else if (!data) {
        } else {
          //this.authService.showToast(data ? data : "Something went wrong!", "Error", "");
          const translatedMsg = {
            message: {
              line_1: data,
              line_2: "",
            },
            style: {
              duration: 2000,
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          const defaultMsg = {
            message: {
              line_1: "Something went wrong!",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {
    this.selectedData.iso2 = this.cell1TelInput.initialCountry;
  }

  numericOnly(event: any): boolean {
    const charcode = event.which ? event.which : event.keyCode;
    if (charcode >= 48 && charcode <= 57) {
      return true;
    }
    return false;
  }

  phoneNumberHasError(hasError: boolean) {
    this.isNumberInvalid = !hasError;
    this.phoneNumberForm.get("phoneNumber").setErrors({
      isNumberInvalid: !hasError,
    });
    if (this.phoneNumberInput) this.phoneInValid = this.phoneNumberInput.nativeElement.value ? true : false;
  }

  getNumericOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }

  getPhoneNumber(event) {
    this.phoneNumber = event?.target?.value ?? "";
    // Allow 10 national digits, or 11 when a leading 0 is present (UK local format)
    const maxLength = 11;
    if (this.phoneNumber.length > maxLength) {
      this.phoneNumber = this.phoneNumber.slice(0, maxLength);
    }
    // Digits only, optional leading 0 (stripped in updateNumber / updateProfilePhoneNumber)
    const phoneNumberRegex = /^0?\d*$/;
    const isFormatValid = phoneNumberRegex.test(this.phoneNumber);
    // Complete local formats: 10 digits (no leading 0), or 11 digits starting with 0
    const isCompleteLengthValid =
      this.phoneNumber.length < 10 ||
      (!this.phoneNumber.startsWith("0") && this.phoneNumber.length === 10) ||
      (this.phoneNumber.startsWith("0") && this.phoneNumber.length === 11);
    const control = this.phoneNumberForm.get("phoneNumber");
    control.setValue(this.phoneNumber);
    if (!isFormatValid || !isCompleteLengthValid) {
      control.setErrors({ ...(control.errors || {}), isNumberInvalid: true });
    } else {
      control.updateValueAndValidity({ emitEvent: false });
    }
  }

  updateNumber() {
    // Added dialcode with new MSN
    const dialCode = this.phoneNumberForm.get("dialCode").value;
    const phoneNumber = this.phoneNumberForm.get("phoneNumber").value;
    const newPhoneNumber = this.phoneNumber?.startsWith("+44")
      ? this.phoneNumber
      : this.phoneNumber?.startsWith("0")
      ? dialCode + this.phoneNumber?.substring(1)
      : dialCode + phoneNumber;
    this.phoneNumber = newPhoneNumber;
    this.authService.validateTwilio(newPhoneNumber)?.subscribe(
      (twilioData: Data) => {
        if (!twilioData?.success) {
          this.authService
            ?.getConstantsMsg(twilioData?.error_code)
            ?.then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
          return;
        }
        if (twilioData?.success) {
          this.progressBar = 100;
          this.sub?.unsubscribe();
          setTimeout(() => {
            this.spinnerAnimation = false;
            this.proceed = false;
            this.changeDetectorRef.detectChanges();
            setTimeout(() => {
              this.proceed = true;
              // this.captchaService.renderCaptcha();
              this.captchaService.captchaSolved$.next(true);
            }, 2000);
          }, 300);
        }
      },
      (err) => {
        return err;
      }
    );
  }

  updateProfilePhoneNumber() {
    if (this.phoneNumberForm && this.phoneNumberForm.get) {
      const dialCode = this.phoneNumberForm.get("dialCode")?.value;
      const phoneNumber = this.phoneNumberForm.get("phoneNumber")?.value;
      this.phoneNumber = phoneNumber.startsWith("0") ? (dialCode + phoneNumber.substring(1)) : (dialCode + phoneNumber);
      this.otpLoader = true;
      this.captchaService.verifyPhoneNumber(this.phoneNumber);
    }
  }

  getAllSelected(event) {
    this.selectedData.iso2 = event.iso2;
    this.selectedData.dialCode = "+" + event.dialCode;
  }

  updateUserMSN(): void {
    this.accountService?.updateUserMSN(this.phoneNumber)?.subscribe(
      (res) => {
        if (res?.status === "rejected" || res?.status === "FAIL") {
          this.authService
            .getConstantsMsg(res?.error_code)
            .then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Something went wrong!",
                  line_2: "",
                },
                style: {
                  icon: "tick circle error.svg",
                  type: "Error",
                },
              };
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            })
            .catch((error) => {
              return error;
            });
          this.bottomSheetRef.dismiss(this.data?.autoOpen ? false : this.selectedData);
          return;
        }

        this.authService
          .getConstantsMsg("1012")
          .then((translatedMsg) => {
            const defaultMsg = {
              message: {
                line_1: "Mobile Number updated Successfully",
                line_2: "",
              },
              style: {
                icon: "tick circle success.png",
                type: "Success",
              },
            };
            this.authService.showToastMessage(translatedMsg, defaultMsg);
          })
          .catch((error) => {
            return error;
          });
        this.bottomSheetRef.dismiss(this.selectedData);
        const phoneNumber = this.phoneNumberForm.value;
        this.accountService.phoneNumberUpdate$.next({
          dialCode: phoneNumber.dialCode,
          number: phoneNumber.phoneNumber,
          iso2: this.selectedData.iso2,
        });
      },
      (err) => {
        return err;
      }
    );
  }

  async updateEmail() {
    try {
      if (!this.phoneNumber) {
        return "Phone number is required";
      }
      let email = this.phoneNumber;
      email = email.replace("+", "");
      email = email + "@lottosocial.com";
      const auth = getAuth();
      const token = localStorage.getItem("fbToken");
      // auto login for reauthentication purpose
      this.tokenValidaterSub = this.authService.getV2CloudFunction("tokenvalidater", { token }).subscribe({
        next: async (res) => {
          const { status, token, token_refresh } = res;
          if (status && token) {
            if (token_refresh) {
              localStorage.setItem("fbToken", token);
            }
            await this.angularFireAuth.signInWithCustomToken(token);
            // update the phone number
            this.authService.getV2CloudFunction("updatephonenumber", { phoneNumber: this.phoneNumber });
            // update the email
            await updateEmail(auth.currentUser, email);
          }
        },
        error: (err) => {
          return err;
        }
      });
      return "Success";
    } catch (error) {
      return error;
    }
  }

  startSpinner() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    this.timer$ = interval(20);
    this.sub = this.timer$?.subscribe(
      (sec) => {
        this.progressBar = 0 + sec;
        this.changeDetectorRef.detectChanges();
      },
      (err) => {
        return err;
      }
    );
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }

  flagsDropdownToggle(value: boolean) {
    CommonVariable.flagsDropdownOpened = value;
  }

  // Handle phone number input changes
  onPhoneNumberInput(phNumber: string): void {

    try {
      this.selectedData.number = this.msn = phNumber?.substring(phNumber.length - 10);
      this.selectedData.dialCode = this.countryCode = phNumber?.split(this.msn)[0]?.split("+")[1];
      this.phoneNumber = this.selectedData.dialCode?.concat(this.selectedData.number);
      if (this.data?.phoneNumber === this.phoneNumber) {
        this.isNumberInvalid = true;
      }
    } catch (e) { }
  }

  checkInput(e) {
    let value;
    const currentInput = e?.target?.value;
    const DEFAULT_VALUE = "+";
    const currentInputDefaultPart = currentInput.substring(0, DEFAULT_VALUE.length);
    // check if the default part is no longer same as DEFAULT
    if (currentInputDefaultPart !== DEFAULT_VALUE) {
      // reset
      value = DEFAULT_VALUE;
      this.phoneNumberForm.get("dialCode").setValue(value);
    }
  }

  onCell1CountryChange(event) {
    // Extract event data outside Angular zone to prevent Java bridge errors on Android WebView
    this.countryCode = event?.iso2;
    this.newDialCode = this.normalizeDialCode(event?.dialCode);

    // Process the form update inside Angular zone to ensure proper event handling
    this.ngZone.run(() => {
      this.phoneNumberForm.get("dialCode").setValue(this.newDialCode);
      this.selectedData.dialCode = this.newDialCode;
      this.selectedData.iso2 = event?.iso2 ?? this.selectedData.iso2;
    });
  }

  telInputObject(event: Data) {
    // Defensive check to prevent race condition where intl-tel-input's internal state
    // object 's' is undefined during library initialization (specifically on iOS/Firefox)
    let detectedDial = CommonVariable.defaultDialCode || "44";
    if (event && typeof event === "object" && event.s && typeof event.s === "object" && event.s.dialCode) {
      detectedDial = event.s.dialCode;
    }
    this.dialCode = String(detectedDial).replace(/^\+/, "");
    const normalized = this.normalizeDialCode(this.dialCode);
    // Prefill form from detected country when profile has not already set a dial code
    const currentDial = this.phoneNumberForm?.get("dialCode")?.value;
    if (!currentDial || currentDial === "+" || currentDial === this.getDefaultDialCode()) {
      this.phoneNumberForm?.get("dialCode")?.setValue(normalized);
      this.selectedData.dialCode = normalized;
    }
  }

  /** Default dial code as a real form value (not placeholder), e.g. +44. */
  private getDefaultDialCode(): string {
    return this.normalizeDialCode(CommonVariable.defaultDialCode || "44");
  }

  /** Ensure dial code always includes a leading +. */
  private normalizeDialCode(dialCode: string | number): string {
    if (dialCode == null || dialCode === "") {
      return `+${CommonVariable.defaultDialCode || "44"}`;
    }
    const asString = String(dialCode).trim();
    if (!asString || asString === "+") {
      return `+${CommonVariable.defaultDialCode || "44"}`;
    }
    return asString.startsWith("+") ? asString : `+${asString}`;
  }

  /**
   * The function `phoneNumberValidation` creates a form group for validating a phone number input with
   * dial code and phone number fields.
   */
  phoneNumberValidation() {
    const defaultDialCode = this.getDefaultDialCode();
    this.selectedData.dialCode = defaultDialCode;
    this.phoneNumberForm = this.formBuilder.group({
      // Real default value (e.g. +44), not an empty control with a grey placeholder
      dialCode: [
        defaultDialCode,
        Validators.compose([Validators.required, Validators.pattern(/^\+\d{1,3}$/)]),
      ],
      // 10 national digits, or 11 with leading 0 (normalized before Twilio in updateNumber)
      phoneNumber: ["", Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(11)])],
    });
  }
}
